import { render, staticRenderFns } from "./UserFamiliesUpdateModal.vue?vue&type=template&id=0cbe7b98&scoped=true&"
import script from "./UserFamiliesUpdateModal.vue?vue&type=script&lang=js&"
export * from "./UserFamiliesUpdateModal.vue?vue&type=script&lang=js&"
import style0 from "./UserFamiliesUpdateModal.vue?vue&type=style&index=0&id=0cbe7b98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbe7b98",
  null
  
)

export default component.exports